import { ApiDatasource } from '../../adapters/io/datasources/ApiDatasource';
import { unwrap } from '../../adapters/io/network/HttpResponse';
import { formatText } from '../../adapters/io/network/utils';
import { ApiDatasourceSpec } from '../../core/datasource';
import { AuthState } from '@okta/okta-auth-js';
import { buildHeader } from './utils/Utils';
import {ChannelTableStructure} from "../indexes/RegionScopeIndexes";

export const getRegionScopes = (
    authState: AuthState,
    datasource: ApiDatasourceSpec = new ApiDatasource(),
    uriFormatter: (uri: string, ...params: unknown[]) => string = formatText
): Promise<ChannelTableStructure.RegionScope[]> => {

    const params = new Map();

    return datasource.remote
        .getData<ChannelTableStructure.RegionScope[]>(uriFormatter(EndpointRegionScope.endPoint.concat(EndpointRegionScope.getRegionScopes), {}), buildHeader(authState), params)
        .then(unwrap);
};

export const EndpointRegionScope = {
    endPoint: '/end-point',
    getRegionScopes: '/region-scope'
};